import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import _ from 'lodash';

import { normalizeViewPhoneNumber } from 'utils/data';

const MIN_PHONE_LENGTH = 10;

dayjs.extend(isToday);

export const formatActivityDateTime = activityDateTime => {
  if (!activityDateTime) {
    return;
  }

  const defaultFormat = 'MMM DD, YYYY hh:mm A';
  const currentYearFormat = 'MMM DD hh:mm A';
  const currentDayFormat = 'hh:mm A';

  const dateTime = dayjs(activityDateTime);
  const currentDate = dayjs();

  const isCurrentYear = dateTime.year() === currentDate.year();
  const isCurrentDay = dateTime.isToday();

  if (isCurrentDay) {
    return dateTime.format(currentDayFormat);
  }

  if (isCurrentYear) {
    return dateTime.format(currentYearFormat);
  }

  return dateTime.format(defaultFormat);
};

export const getContactInfoStringByEmail = (contacts, email) => {
  const contactInfo = contacts.find(contact => contact.value.toLowerCase() === email);

  return contactInfo ? contactInfo.label : `<${email}>`;
};

export const getRecipientsWithNames = ({ contacts, receivers, separator = ', ' }) =>
  receivers
    .map(receiverEmail => getContactInfoStringByEmail(contacts, receiverEmail))
    .join(separator);

export const getFullNameByNumber = (contacts, phoneNumber) => {
  const contact = contacts.find(contact => contact.phoneNumber === phoneNumber);

  if (contact) {
    return contact.fullName || '';
  }
};

// number can be 4 digit extension number, which is incorrectly normalized by common util
export const normalizeNumber = value => {
  if (value?.length < MIN_PHONE_LENGTH) {
    return value;
  }

  return normalizeViewPhoneNumber(value);
};

export const getChatName = (subjectProperty, primaryBorrowerLastName) => {
  const propertyAddress = subjectProperty?.address?.fullAddress;

  return [primaryBorrowerLastName, propertyAddress].filter(Boolean).join(' - ');
};

export const getContactsOptionLabelCallback = option => {
  const label = _.get(option, 'label', '');
  const description = _.get(option, 'description', '');

  return [label, description].filter(Boolean).join(' ');
};
